import type { IAPI } from '../../apiResponse';
import { getRequest, type IRequestOptions } from '../../httpClient';
import {
  getPublicChallengesByTypeV1ResponseSchema,
  type IGetPublicChallengesByTypeV1ResponseData,
} from './get-public-challenges-by-type-v1-response';

export async function getPublicChallengesByTypeV1Api(type: string, options?: IRequestOptions) {
  return getRequest<IAPI<IGetPublicChallengesByTypeV1ResponseData>>({
    path: `/challenges/type/${encodeURIComponent(type)}/v1`,
    options,
    schema: getPublicChallengesByTypeV1ResponseSchema,
  });
}
